import { ICrossSellItemsCTAStatuses } from '@models/ICrossSellItemsCTAStatuses';
import ITabbedProductListingItem from '@models/ITabbedProductListingItem';
import CrossSellProductCTAStatusEnum from '@models/enums/CrossSellProductCTAStatusEnum';
import { useEffect, useState } from 'react';

const useTabbedProductsCTAStatuses = (tabs: ITabbedProductListingItem[]) => {
  const getItemsCTAStatuses = (currentTabs?: ITabbedProductListingItem[]) =>
    (currentTabs || []).reduce((tabsAcc, currentTab, tabIndex) => {
      const currentTabItems = (currentTab?.items || []).reduce<
        Record<number, CrossSellProductCTAStatusEnum>
      >(
        (tabItemsAcc, item, tabItemIndex) => ({
          ...tabItemsAcc,
          ...{
            [`${tabItemIndex}`]: item.inCart
              ? CrossSellProductCTAStatusEnum.Remove
              : CrossSellProductCTAStatusEnum.AddToBasket,
          },
        }),
        {}
      );

      return {
        ...tabsAcc,
        ...{
          [`${tabIndex}`]: currentTabItems,
        },
      };
    }, {});

  const [itemsCTAStatuses, setItemsCTAStatuses] =
    useState<ICrossSellItemsCTAStatuses>(getItemsCTAStatuses(tabs));

  // biome-ignore lint/correctness/useExhaustiveDependencies: Intentional Missing Dependencies
  useEffect(() => {
    setItemsCTAStatuses(getItemsCTAStatuses(tabs));
  }, [tabs]);

  const handleUpdateItemCTAStatus = (
    activeTabIndex: number,
    itemIndex: number,
    newCtaStatus: CrossSellProductCTAStatusEnum
  ) => {
    setItemsCTAStatuses((previousState) => ({
      ...previousState,
      [`${activeTabIndex}`]: {
        ...previousState[activeTabIndex],
        [`${itemIndex}`]: newCtaStatus,
      },
    }));
  };

  return { itemsCTAStatuses, handleUpdateItemCTAStatus };
};

export default useTabbedProductsCTAStatuses;
